import {
  Environment,
  LeadStatusType
} from "@coxauto-ui/cxm/communications/interfaces";
import { fetchWrapper } from "@coxauto-ui/core-http";
import { getBaseUrl, getHeader } from "../config";

export async function getLeadStatusType(
  env: Environment,
  autoLeadId: number
): Promise<LeadStatusType> {
  const url = `${getBaseUrl(env)}cxm/lead-status?autoLeadId=${autoLeadId}`;
  const header = await getHeader();

  const response = await fetchWrapper.getAsync<string>(url, header);
  if (!response?.hasError && response?.data) {
    // Get request returns lowercase. Converting to uppercase
    const statusKey =
      response.data.toUpperCase() as keyof typeof LeadStatusType;
    if (statusKey in LeadStatusType) {
      return LeadStatusType[statusKey];
    }
    throw new Error(`Invalid lead status received: ${response.data}`);
  }
  throw new Error(
    `Failed to fetch lead status. StatusCode: ${response?.statusCode}, Error: ${response?.error}`
  );
}
